import { VehiclePriceSettingsComponent } from './../../vehicles/vehicle-price-settings/vehicle-price-settings.component';
import { VehicleStatusSelectorComponent } from './../../vehicles/vehicle-status-selector/vehicle-status-selector.component';
import { UserService } from 'app/services/user.service';
import { SecurityRight } from 'app/utility/enums';
import { Constants } from 'app/utility/constants';
import { VehicleModel, VehicleSummaryModel } from 'app/models/dms/vehicle.model';
import { Component, Input, OnInit } from '@angular/core';
import { PopoverController, NavController, ModalController } from '@ionic/angular';

@Component({
    template: `
		<ion-list lines="none" class="ion-no-margin" inset="false" mode="md">
		  @if (hasPermission('view')) {
		    <ion-item (click)="performAction('view')">
		      <ion-label>View</ion-label>
		    </ion-item>
		  }
		  @if (hasPermission('activity')) {
		    <ion-item (click)="performAction('activity')">
		      <ion-label>Add activity</ion-label>
		    </ion-item>
		  }
		  @if (hasPermission('purchase-order')) {
		    <ion-item (click)="performAction('purchase-order')">
		      <ion-label>Add purchase order</ion-label>
		    </ion-item>
		  }
		  @if (hasPermission('activity')) {
		    <ion-item (click)="performAction('opportunities')">
		      <ion-label>Opportunities</ion-label>
		    </ion-item>
		  }
		  @if (hasPermission('price')) {
		    <ion-item (click)="performAction('price')">
		      <ion-label>Price</ion-label>
		    </ion-item>
		  }
		  @if (hasPermission('status')) {
		    <ion-item (click)="performAction('status')">
		      <ion-label>Status</ion-label>
		    </ion-item>
		  }
		  @if (hasPermission('reports')) {
		    <ion-item [button]="true" [detail]="true" id="nested-trigger-vehicle-reports">
		      <ion-label>Reports</ion-label>
		    </ion-item>
		  }
		  <ion-popover trigger="nested-trigger-vehicle-reports" [dismissOnSelect]="true" side="end">
		    <ng-template>
		      <ion-content>
		        <ion-list>
		          <ion-item (click)="performAction('buyerscore')">
		            <ion-label>BuyerScore vehicle report</ion-label>
		          </ion-item>
		          <ion-item (click)="performAction('cinReport')">
		            <ion-label>CIN</ion-label>
		          </ion-item>
		          <ion-item (click)="performAction('fueleconomy')">
		            <ion-label>Fuel economy label</ion-label>
		          </ion-item>
		          <ion-item (click)="performAction('ratings')">
		            <ion-label>Fuel economy &amp; ratings</ion-label>
		          </ion-item>
		          @if (hasPermission('financial-details')) {
		            <ion-item (click)="performAction('financial-details')">
		              <ion-label>Financial details</ion-label>
		            </ion-item>
		          }
		          @if (hasPermission('mr1b')) {
		            <ion-item (click)="performAction('mr1b')">
		              <ion-label>MR1B (Text Only)</ion-label>
		            </ion-item>
		          }
		          @if (hasPermission('purchase-agreement')) {
		            <ion-item (click)="performAction('purchase-agreement')">
		              <ion-label>Purchase agreement</ion-label>
		            </ion-item>
		          }
		          <ion-item (click)="performAction('summarysheet')">
		            <ion-label>Summary sheet</ion-label>
		          </ion-item>
		          <ion-item (click)="performAction('stockid')">
		            <ion-label>Stock ID card</ion-label>
		          </ion-item>
		        </ion-list>
		      </ion-content>
		    </ng-template>
		  </ion-popover>
		  @if (hasPermission('copy')) {
		    <ion-item (click)="performAction('copy')">
		      <ion-label>Copy vehicle</ion-label>
		    </ion-item>
		  }
		  @if (hasPermission('sell')) {
		    <ion-item (click)="performAction('sell')">
		      <ion-label>Sell vehicle</ion-label>
		    </ion-item>
		  }
		  @if (hasPermission('change-activation')) {
		    <ion-item-divider></ion-item-divider>
		  }
		  @if (hasPermission('change-activation')) {
		    <ion-item (click)="performAction('change-activation')">
		      @if (!vehicleIsActive) {
		        <ion-label>Activate</ion-label>
		      }
		      @if (vehicleIsActive) {
		        <ion-label>Deactivate</ion-label>
		      }
		    </ion-item>
		  }
		  @if (hasPermission('delete-vehicle')) {
		    <ion-item (click)="performAction('delete-vehicle')">
		      <ion-label>Delete vehicle</ion-label>
		    </ion-item>
		  }
		</ion-list>
		`,
    styles: [`
		ion-item-divider {
			min-height: 0px;
		}
	`],
    standalone: false
})

export class VehicleListItemPopover implements OnInit
{
    vehicleIsActive: boolean = true;
    constructor(
        private popoverCtrl: PopoverController,
        private navCtrl: NavController,
        private userService: UserService,
        private modalController: ModalController
    )
    {
    }

    @Input() vehicle: VehicleSummaryModel;
    @Input() additionalProperties: any;
    @Input() isExpress: boolean = false;

    ngOnInit()
    {
        this.vehicleIsActive = this.additionalProperties as boolean;
    }
    async onDismiss()
    {
        try
        {
            await this.popoverCtrl.dismiss();
        } catch (e)
        {
            //click more than one time popover throws error, so ignore...
        }
    }

    async performAction(action: string)
    {
        try
        {
            await this.popoverCtrl.dismiss(action);
        }
        catch (e)
        {
            //click more than one time popover throws error, so ignore...
        }
    }

    hasPermission(action: string): boolean
    {
        switch (action)
        {
            case 'view':
                return this.userService.hasUserRight(SecurityRight.VehiclesTabsGeneralView)
                break;
            case 'expenses':
                return this.userService.hasUserRight(SecurityRight.VehiclesTabsExpensesView);
                break;
            case 'activity':
                return this.userService.hasUserRights([SecurityRight.OpportFunctionsCreateOther, SecurityRight.OpportFunctionsCreatePriceMyTrade, SecurityRight.OpportFunctionsCreateTestDrive]);
                break;
            case 'purchase-order':
                return this.userService.hasAnyRight(this.userService.rights, [SecurityRight.AccountingPurchaseOrders, SecurityRight.AccountingPurchaseOrdersFunctionsCreate, SecurityRight.AccountingPurchaseOrdersTabsBasicsEdit]);
                break;
            case 'features':
                return this.userService.hasUserRights([
                    SecurityRight.VehiclesTabsInteriorEdit,
                    SecurityRight.VehiclesTabsMechanicalEdit
                ]);
                break;
            case 'price':
            case 'status':
                return this.userService.hasUserRight(SecurityRight.VehiclesTabsAdminEdit);
                break;
            case 'change-activation':
                return this.userService.hasUserRights([SecurityRight.VehiclesFunctionsDelete]) && this.vehicle.vehicleStatus.caption !== Constants.Vehicle_Status_Sold_Caption;
                break;
            case 'images':
                return this.userService.hasUserRight(SecurityRight.VehiclesTabsImagesView);
                break;
            case 'sell':
                return !this.vehicle.vehicleStatusCaption.includes(Constants.Vehicle_Status_Sold_Caption) && this.userService.hasUserRight(SecurityRight.VehiclesFunctionsDelete);
            case 'copy':
                return this.userService.mcMinVersion("3.2.22") && this.userService.hasUserRight(SecurityRight.VehiclesFunctionsCreate);
            case 'reports':
                return this.userService.mcMinVersion("3.2.23");
            case 'mr1b':
            case 'financial-details':
            case 'purchase-agreement':
                return !this.isExpress;
            case 'delete-vehicle':
                return !this.isExpress && this.userService.mcMinVersion("3.2.23") && this.userService.hasUserRight(SecurityRight.VehiclesFunctionsDelete) && this.vehicle.vehicleStatus.caption !== Constants.Vehicle_Status_Sold_Caption;
            default:
                // console.log(action + " has no permission");
                break;
        }
    }
}
